import {
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { logoInstagram } from "ionicons/icons";
import React, { useState } from "react";
import "./WEFacebook.css";

function WEFacebook() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-down">
        <IonIcon
          icon={logoInstagram}
          slot="start"
          className="ion-icon"
        ></IonIcon>
        <IonLabel className="ion-text-wrap">Data Scientist Intern @ Instagram</IonLabel>

        <IonModal
          isOpen={showModal}
          className="ion-modal-popup"
          backdropDismiss="false"
        >
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>Data Scientist Intern @ Instagram</b>
            <br />
            <p>
              During Summer 2021, I returned to Instagram as a data scientist
              intern. I analyzed adoption and opportunities for
              their branded content ads product.
            </p>
            <p>
              In Summer 2020, I was a data scientist intern through Facebook
              University for Analytics, where I modeled user behavior and
              analyzed time spent metrics at Instagram.{" "}
            </p>
            <IonButton
              className="ion-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </IonButton>

            <br />
          </IonText>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default WEFacebook;
